export const API = process.env.REACT_APP_API_URL || 'https://copy-api.unbounce.com/api';

export const url2ads = () => `${API}/url2prompt/ads`;
export const getAds = (requestID: string) => `${API}/url2prompt/ads/${requestID}`;
export const getCount = () => `${API}/url2prompt/generated_ads`;
